/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Downgrade_Btn_RemoveInputs */



/**
* | output |
* | --- |
* | "Schedule removal" |
*
* @param {Sub_Addons_Confirm_Downgrade_Btn_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_downgrade_btn_remove = /** @type {((inputs?: Sub_Addons_Confirm_Downgrade_Btn_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Downgrade_Btn_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernung planen")
	return /** @type {LocalizedString} */ ("Schedule removal")
});